import {
  Avatar,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Divider,
  Grid,
  Grow,
  IconButton,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ReactElement } from "react";
import SwitchAccountIcon from '@mui/icons-material/SwitchAccount';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "redux/store/store";
import {
  getAllUserList,
  searchUserDetails,
} from "redux/actions/userAction";
import { ListSkeleton } from "components/listSkeleton";
import DialogBox from "components/dialogBox/dialog";
import { getKeycloakToken } from "config/keycloak";
import { RequestSetUserRole, Status} from "api/models/heartintune-profile-service/heartintune-profile_pb";
import { HeartIntuneProfileService } from "api/models/heartintune-profile-service/heartintune-profile_pb_service";
import { HEARTINTUNE_PROFILE_SERVICE_HOST } from "api/serviceEndpoints";
import { UnaryOutput } from "@improbable-eng/grpc-web/dist/typings/unary";
import { grpc } from "@improbable-eng/grpc-web";
import style from "../../../src/pages/app/resources/articles/index.module.scss";
import { ClearInitCoach } from "redux/reducers/userReducer";

interface State {
  editing?: boolean;
  editItem?: any;
  updateRole?: boolean;
  deleteItemId?: number;
  roleUpdateItemId?: number;
  showModal?: boolean;
  userId?: number;
  email?: string;
  updateRoleModal?: boolean;
}

const userRole = [
  "UNKNOWN_ROLE",
  "SUPER_ADMIN",
  "ADMIN",
  "CONTENT_OWNER",
  "USER",
  "PRECEPTOR",
  "CUSTOM_ROLE",
  "SCHEDULER",
  "EVENTS_ANNOUNCEMENTS_ADMIN_ROLE",
  "BHE_CONTENT_MANAGER"
];


export default function UserModal({
  onClose,
  setSnackBar,
}: // setsearchUser,
any): ReactElement {
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.user);
  const userState: any = useSelector((state: RootState) => state.user);
  const defaultCoach = userState.initialCoach;
  
  const initialUpdateState = {
    updateRoleModal: false,
    roleUpdateItemId: 0,
  };


  const [currentIndex,] = useState(0);
  const [searchFilter,] = useState(defaultCoach? "email": "name");
  const [searchUser, setsearchUser] = useState(defaultCoach || "");
  const [pageNumber, setpageNumber] = useState(0);
  const [pageSize, setpageSize] = useState(10);
  const [updateRole, setUpdateRole] = useState<State>(initialUpdateState);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(()=>{
    dispatch(ClearInitCoach())
  }, []);

  useEffect(() => {
    if (searchUser !== "") {
      dispatch(
        searchUserDetails({
          searchFilter,
          searchInput: searchUser,
          pageNumber,
          pageSize,
        })
      );
    } else {
      dispatch(getAllUserList(pageSize, pageNumber + 1));
    }
  }, [dispatch, pageNumber, pageSize, searchFilter]);



  const handleChangePage = (event: any, newPage: number) => {
    setpageNumber(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setpageSize(+event.target.value);
    setpageNumber(0);
  };

  const onRoleUpdate = (userData: any) => {
    setUpdateRole({ updateRoleModal: true, roleUpdateItemId: userData.id });
  };


  const _updateUser = () => {
    if (updateRole.roleUpdateItemId) _updateUserAsPreceptor(updateRole.roleUpdateItemId);
    return true;
  };

  const handleDeleteClose = () => {
    setUpdateRole({ updateRoleModal: false });
  };


  const _updateUserAsPreceptor = async (_id: number) => {
    try {
      const jwtToken = await getKeycloakToken();
      const reqBody: RequestSetUserRole = new RequestSetUserRole();
      reqBody.setUserid(_id);
      reqBody.setUserrole(5);
      grpc.unary(HeartIntuneProfileService.setUserRole, {
        host: HEARTINTUNE_PROFILE_SERVICE_HOST,
        request: reqBody,
        metadata: {
          Authorization: `Bearer ${jwtToken}`,
        },
        onEnd: (res: UnaryOutput<Status>) => {
          const { status, message } = res;
          if (status === grpc.Code.OK) {
           setSnackBar({
              open: true,
              severity: "success",
              message: "The user's role has been successfully changed to Preceptor.",
            });
            setUpdateRole({ updateRoleModal: false, roleUpdateItemId: 0 });
            onClose(true);
            // dispatch(getAllUserList(pageSize, pageNumber + 1));
          } else {
            setSnackBar({
              open: true,
              severity: "error",
              message:
                "User already exists with this email. Couldn't change role to preceptor",
            });
            onClose(true);
          }
        },
      });
    } catch (err) {
      setIsLoading(false);
      setSnackBar({
        open: true,
        severity: "error",
        message: "error in change role to preceptor",
      });
      onClose(true);
    }
  };


  const userLang = (selectedLang: number) => {
    switch (selectedLang) {
      case 1:
        return "English";
      case 2:
        return "English";
      case 3:
        return "Hindi";
      case 4:
        return "Telugu";
      case 5:
        return "Gujarati";
      case 6:
        return "Tamil";
      case 7:
        return "Kannada";
      case 8:
        return "Marathi";
      case 9:
        return "Italian";
      case 10:
        return "Russian";
      case 11:
        return "Spanish";
      case 12:
        return "French";
      case 13:
        return "Portuguese";
      case 14:
        return "German";
      case 15:
        return "Bengali";
      case 16:
        return "Malayalam";
      case 17:
        return "Ukrainian";
      case 18:
        return "Odiya";
      case 19:
        return "English US";
      case 20:
        return "English AUS";
      case 21:
        return "Punjabi";
      case 22:
        return "Japanese";
    }
  };

  const userProvider = (providerId: number) => {
    switch (providerId) {
      case 0:
        return "Unknown";
      case 1:
        return "Facebook";
      case 2:
        return "Google";
      case 3:
        return "Apple";
      case 4:
        return "Email";
      case 5:
        return "Mobile";
      default:
        return "N/A";
    }
  };

  const renderUserList = (data: any) => {
    return (
      <div>
        {data.length ? (
          <div>
            <TableContainer style={{ maxHeight: "400px" }}>
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead>
                  <TableRow style={{ fontWeight: "bold" }}>
                    <TableCell align="left">Image</TableCell>
                    <TableCell align="center">User Id</TableCell>
                    <TableCell align="left"> Name</TableCell>
                    <TableCell align="left">Email</TableCell>
                    <TableCell align="left">Mobile No.</TableCell>
                    <TableCell align="center">Language</TableCell>
                    <TableCell align="center">Provider</TableCell>
                    <TableCell align="center">Role</TableCell>
                    <TableCell align="center">Switch to preceptor</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data && Array.isArray(data) && data.map((user: any, x: any) => {
                    return (
                      <React.Fragment key={x}>
                        <TableRow hover>
                          <TableCell align="center">
                            <Avatar
                              alt={user.displayname}
                              src={user.profileurl}
                            />
                          </TableCell>
                          <TableCell align="center">{user.id}</TableCell>
                          <TableCell>{user.displayname}</TableCell>
                          <TableCell>{user.email}</TableCell>
                          <TableCell>{user.mobilenumber}</TableCell>
                          <TableCell align="center">
                            {userLang(user.selectedlanguage)}
                          </TableCell>
                          <TableCell align="center">
                            {userProvider(user.provider)}
                          </TableCell>
                          <TableCell align="center">
                            {userRole[user.role]}
                          </TableCell>
                          <TableCell align="center">
                            <IconButton
                              onClick={() => {
                                onRoleUpdate(user);
                              }}
                              size="small"
                              disabled={user.role === 5}
                            >
                              <SwitchAccountIcon  />
                            </IconButton>
                          </TableCell>

                        </TableRow>
                      </React.Fragment>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 20, 50, 100]}
              component="div"
              count={state.usersList.users.totalcount}
              page={pageNumber}
              onPageChange={handleChangePage}
              rowsPerPage={pageSize}
              onRowsPerPageChange={handleChangeRowsPerPage}
              style={{ borderTop: "1px solid rgba(0, 0, 0, 0.12)" }}
              className={style.scrollbar}
            />
          </div>
        ) : (
          <Box height={350}>
            <Grid
              container
              style={{
                height: "100%",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="h6" color="textSecondary">
                No user data
              </Typography>
            </Grid>
          </Box>
        )}
      </div>
    );
  };

  return (
    <Container>
      <Grid container>
        <Grid item xs={12}>
          <Card className="mt-3 mb-5">
            <Grow
              in={currentIndex === 0}
              mountOnEnter
              unmountOnExit
              style={{ transformOrigin: "0 0 0" }}
              {...(currentIndex === 0 ? { timeout: 1000 } : {})}
            >
              <div>
                {isLoading && (
                  <CircularProgress
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "50%",
                      zIndex: 5,
                    }}
                  />
                )}
                <CardContent>
                  <Paper>
                    {state.usersList.loading
                      ? ListSkeleton()
                      : renderUserList(state.usersList.users.userinfoList)}
                  </Paper>
                </CardContent>
                <DialogBox
                  open={updateRole.updateRoleModal || false}
                  onClose={handleDeleteClose}
                  onCancel={handleDeleteClose}
                  onConfirm={_updateUser}
                  type={"cancel"}
                  title={`Sure !! Do you want to update this user's role to Preceptor?`}
                />

              </div>
            </Grow>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
